import { useRef } from 'react';
import { Button, Card, Col, Row, Typography } from 'antd';
import { DownloadOutlined, CopyOutlined } from '@ant-design/icons';
import { QRCodeSVG } from 'qrcode.react';
import { useMenu } from '../context/MenuContext';
import { PUBLIC_MENU_BASE } from '../config';

const { Title, Text, Paragraph } = Typography;

export default function QRCode() {
  const { menu } = useMenu();
  const svgRef = useRef<HTMLDivElement>(null);

  const menuUrl = `${PUBLIC_MENU_BASE}/view/${menu.id}`;

  function copyUrl() {
    navigator.clipboard.writeText(menuUrl).catch(() => { /* ignore */ });
  }

  function downloadSVG() {
    if (!svgRef.current) return;
    const svg = svgRef.current.querySelector('svg');
    if (!svg) return;
    const blob = new Blob([svg.outerHTML], { type: 'image/svg+xml' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `${menu.restaurantName.replace(/\s+/g, '-').toLowerCase()}-menu-qr.svg`;
    a.click();
    URL.revokeObjectURL(url);
  }

  return (
    <div style={{ padding: 24 }}>
      <Title level={3} style={{ marginBottom: 24 }}>QR Code & Share</Title>

      <Row gutter={24}>
        <Col xs={24} md={10}>
          <Card style={{ textAlign: 'center' }}>
            <div ref={svgRef} style={{ display: 'flex', justifyContent: 'center', marginBottom: 16 }}>
              <QRCodeSVG
                value={menuUrl}
                size={256}
                level="H"
                includeMargin
                imageSettings={{
                  src: '',
                  width: 0, height: 0,
                  excavate: false,
                }}
              />
            </div>
            <Text strong style={{ display: 'block', marginBottom: 8 }}>{menu.restaurantName}</Text>
            <Text type="secondary" style={{ fontSize: 12, wordBreak: 'break-all' }}>{menuUrl}</Text>
            <Row gutter={8} style={{ marginTop: 16 }}>
              <Col span={12}>
                <Button icon={<CopyOutlined />} onClick={copyUrl} block>Copy URL</Button>
              </Col>
              <Col span={12}>
                <Button type="primary" icon={<DownloadOutlined />} onClick={downloadSVG} block>Download SVG</Button>
              </Col>
            </Row>
          </Card>
        </Col>

        <Col xs={24} md={14}>
          <Card title="How to use your QR code">
            <Paragraph>
              <ol style={{ paddingLeft: 20 }}>
                <li>Download the QR code SVG or screenshot it.</li>
                <li>Print it on table tents, posters, or your storefront.</li>
                <li>Guests scan with any smartphone camera — no app needed.</li>
                <li>They'll see your live digital menu instantly.</li>
              </ol>
            </Paragraph>
            <Divider />
            <Text strong>Menu URL</Text>
            <div style={{ background: '#f5f5f5', padding: '8px 12px', borderRadius: 6, marginTop: 8, fontFamily: 'monospace', fontSize: 13 }}>
              {menuUrl}
            </div>
            <Paragraph type="secondary" style={{ marginTop: 12, fontSize: 12 }}>
              Share this link directly via WhatsApp, Instagram bio, or any messaging app.
              Your menu updates instantly — no need to reprint QR codes.
            </Paragraph>
          </Card>
        </Col>
      </Row>
    </div>
  );
}

function Divider() {
  return <div style={{ height: 1, background: '#f0f0f0', margin: '12px 0' }} />;
}
